const medicoPorMatriculaInitialState = {
  medicoPorMatricula: {
    data: [],
    loading: false,
    error: false,
  },
};

export default medicoPorMatriculaInitialState;
